import ExcelJS from 'exceljs';
import { APP_NAME } from './appIdentity';

export const EXCEL_BRAND = 'FFD32F2F';
export const EXCEL_BRAND_TEXT = 'FFFFFFFF';
export const EXCEL_HEADER_FILL = 'FFF5F5F5';
export const EXCEL_BORDER = 'FFE0E0E0';
export const EXCEL_CREATOR = APP_NAME;

export function createWorkbook() {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = EXCEL_CREATOR;
  workbook.created = new Date();
  return workbook;
}

export function styleHeaderRow(row) {
  row.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: EXCEL_BRAND_TEXT }, size: 11 };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: EXCEL_BRAND } };
    cell.alignment = { vertical: 'middle', wrapText: true };
    cell.border = {
      top: { style: 'thin', color: { argb: EXCEL_BORDER } },
      left: { style: 'thin', color: { argb: EXCEL_BORDER } },
      bottom: { style: 'thin', color: { argb: EXCEL_BORDER } },
      right: { style: 'thin', color: { argb: EXCEL_BORDER } },
    };
  });
  row.height = 22;
}

export function styleBodyRow(row, { alt = false } = {}) {
  row.eachCell((cell) => {
    cell.alignment = { vertical: 'top', wrapText: true };
    cell.border = {
      top: { style: 'thin', color: { argb: EXCEL_BORDER } },
      left: { style: 'thin', color: { argb: EXCEL_BORDER } },
      bottom: { style: 'thin', color: { argb: EXCEL_BORDER } },
      right: { style: 'thin', color: { argb: EXCEL_BORDER } },
    };
    if (alt) {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: EXCEL_HEADER_FILL } };
    }
  });
}

export function autoFitColumns(worksheet, widths = {}) {
  worksheet.columns.forEach((column) => {
    const key = column.key || column.letter;
    if (widths[key]) {
      column.width = widths[key];
      return;
    }
    let maxLength = 12;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const value = cell.value == null ? '' : String(cell.value);
      maxLength = Math.max(maxLength, Math.min(value.length + 2, 60));
    });
    column.width = maxLength;
  });
}

export function addSummarySheet(
  workbook,
  {
    title,
    rows,
    labelColumnWidth = 18,
    valueColumnWidth = 42,
  },
) {
  const sheet = workbook.addWorksheet('Povzetek', {
    views: [{ showGridLines: false }],
  });

  sheet.mergeCells('A1', 'D1');
  const titleCell = sheet.getCell('A1');
  titleCell.value = title;
  titleCell.font = { bold: true, size: 16, color: { argb: EXCEL_BRAND } };
  titleCell.alignment = { vertical: 'middle' };

  rows.forEach((row, index) => {
    const excelRow = sheet.getRow(index + 3);
    excelRow.getCell(1).value = row[0];
    excelRow.getCell(1).font = { bold: true };
    excelRow.getCell(2).value = row[1];
  });

  sheet.getColumn(1).width = labelColumnWidth;
  sheet.getColumn(2).width = valueColumnWidth;
}

export async function downloadWorkbook(workbook, filename) {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
